import { useMultisynqContext as t } from "@multisynq/react";
import { useEffect as f, useCallback as r } from "react";
function m(u, o) {
  const { view: e, model: i } = t();
  return f(() => {
    if (e) {
      const n = (s) => o(...s);
      return e.subscribe(u, "call", n), () => e.unsubscribe(u, "call", n);
    }
  }, [u, e, o]), r(
    (...n) => {
      e && i ? e.publish(i.id, "functionTogether", { rtKey: u, args: n }) : o(...n);
    },
    [u, e, i, o]
  );
}
export {
  m as default
};
